import Panel from '../../apricot/Panel';
import { dollarFormat } from '../../../numeral';
import styles from '../../../../sass/status.module.scss';
export default (function (props) {
  var PanelBody = function PanelBody(_ref) {
    var _ref$totalCost = _ref.totalCost,
      totalCost = _ref$totalCost === void 0 ? 0 : _ref$totalCost;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles['status-title']
    }, "Total Cost"), /*#__PURE__*/React.createElement("div", {
      className: styles['status-number']
    }, dollarFormat(totalCost)));
  };
  return /*#__PURE__*/React.createElement(Panel, {
    title: "Cost",
    body: /*#__PURE__*/React.createElement(PanelBody, props)
  });
});